var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    fill: "#EB956A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 7.31939C13 4.38804 10.5309 2 7.5 2C4.46912 2 2 4.38804 2 7.31939C2 8.53237 2.40499 9.66953 3.17577 10.6172C3.37173 10.8572 3.73753 10.8951 3.98575 10.7056C4.23397 10.5161 4.27316 10.1623 4.0772 9.92223C3.46318 9.17676 3.14964 8.27967 3.14964 7.31939C3.14964 5.00716 5.0962 3.12453 7.48694 3.12453C9.87767 3.12453 11.8242 5.00716 11.8242 7.31939C11.8242 9.63163 9.96912 11.4132 7.66983 11.5143V11C7.66983 10.6589 7.27791 10.4441 6.97743 10.6336L5.5 11.7162C5.22565 11.8931 5.22565 12.2721 5.5 12.4364C5.77435 12.6007 6.9905 13.3664 6.9905 13.3664C7.29097 13.5559 7.6829 13.3538 7.6829 13V12.6259C10.6354 12.5375 13 10.1876 13 7.31939Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.79748 4.5C6.36249 4.5 6 4.84783 6 5.26522L6 8.08694C6 8.38259 6.18125 8.64346 6.45311 8.78259L8.27502 9.87391C8.38376 9.92609 8.51064 9.96087 8.63751 9.96087C8.9275 9.96087 9.21749 9.80435 9.36249 9.52609C9.56186 9.14348 9.39874 8.67391 9 8.5L7.63121 7.61738V5.26522C7.59496 4.84783 7.23247 4.5 6.79748 4.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/Pending.bec4997fff8c94708c81fd0835b5ea58.svg";
export { ForwardRef as ReactComponent };